/* Classic Warehouse — delivery estimator (product page, cart page, cart drawer) */
(function () {
  'use strict';
  var cfgEl = document.getElementById('cw-dlv-config');
  if (!cfgEl) return;
  var CFG = JSON.parse(cfgEl.textContent);
  var KEY = 'cw_dlv';
  var STATE_CODE = { N: 'NSW', A: 'ACT', V: 'VIC', Q: 'QLD', S: 'SA', T: 'TAS', W: 'WA', D: 'NT' };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- rates ---------- */
  function lines(s) { return String(s || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean); }
  var BANDS = lines(CFG.bands).map(function (l) { var p = l.split('|'); return { max: parseFloat(p[0]), price: parseFloat(p[1]) }; })
    .filter(function (b) { return b.max > 0 && !isNaN(b.price); }).sort(function (a, b) { return a.max - b.max; });
  var STATES = {};
  lines(CFG.states).forEach(function (l) { var p = l.split('|'); STATES[p[0].trim().toUpperCase()] = { extra: parseFloat(p[1]) || 0, lead: (p[2] || '').trim() }; });
  var METRO = lines(String(CFG.metro || '').replace(/,/g, '\n')).map(function (r) { var p = r.split('-'); return [parseInt(p[0], 10), parseInt(p[1] || p[0], 10)]; });
  var SAMPLES = parseFloat(CFG.samples) || 0;

  function isMetro(pc) { var n = parseInt(pc, 10); return METRO.some(function (r) { return n >= r[0] && n <= r[1]; }); }
  function money(n) {
    var cents = Math.round(n * 100);
    var s = (cents / 100).toFixed(cents % 100 ? 2 : 0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + s;
  }
  function kgText(kg) { return kg >= 1000 ? (Math.round(kg / 10) / 100).toLocaleString('en-AU') + ' t' : Math.max(1, Math.round(kg)).toLocaleString('en-AU') + ' kg'; }

  function quote(kg, loc) {
    var st = STATES[loc.state];
    if (!st) return { status: 'nostate' };
    if (kg <= 0.5) return { status: 'ok', price: SAMPLES, method: 'Samples by post' };
    var band = null;
    for (var i = 0; i < BANDS.length; i++) if (kg <= BANDS[i].max) { band = BANDS[i]; break; }
    if (!band) return { status: 'quote', max: BANDS.length ? BANDS[BANDS.length - 1].max : 0 };
    var lead = loc.state === 'NSW' && isMetro(loc.pc) && CFG.metroLead ? CFG.metroLead : st.lead;
    return { status: 'ok', price: band.price + st.extra, band: band, lead: lead, method: 'Tailgate delivery to the kerb' };
  }

  /* ---------- postcodes: every Australian delivery postcode, run-length encoded as PPPPS[n] ---------- */
  var PC_DATA = '0810D,0812D,0820D,0822D,0829D1,0832D,0834D,0836D1,0839D,0850D,0852D2,0862D,0870D,0872D3,0880D,0885D,2000N,2006N5,2015N35,2055N,2060N17,2079N11,2092N5,2099N9,2110N12,2125N3,2130N8,2140N8,2150N18,2170N3,2175N4,2190N10,2203N11,2216N18,2250N1,2256N9,2267N,2278N,2280N7,2289N11,2302N7,2311N1,2315N15,2333N14,2350N,2352N9,2365N,2369N3,2379N3,2386N2,2390N,2395N11,2408N3,2415N,2420N11,2439N2,2443N7,2452N4,2460N,2462N4,2469N21,2500N,2502N,2505N1,2508N,2515N4,2525N5,2533N8,2545N1,2548N3,2555N5,2563N25,2590N,2594N,2600A7,2609A,2611A1,2614A1,2617A,2618N15,2640N13,2655N1,2658N2,2663N,2665N1,2668N1,2671N1,2675N,2678N,2680N1,2700N3,2705N2,2710N7,2720N2,2725N2,2729N10,2745N,2747N3,2752N2,2756N7,2765N5,2773N7,2782N5,2790N5,2797N3,2803N7,2820N1,2823N2,2827N9,2839N1,2842N8,2852N,2864N7,2873N7,2898N1,2900A,2902A4,2911A3,3000V,3002V4,3008V,3010V3,3015V1,3018V16,3036V32,3070V6,3078V1,3081V10,3093V4,3099V,3101V8,3111V,3113V3,3121V35,3158V5,3165V10,3177V25,3204V3,3211V17,3230V13,3249V2,3254V,3260V,3264V23,3289V,3292V2,3300V5,3309V3,3314V1,3317V2,3321V4,3328V10,3340V2,3345V,3350V2,3355V3,3360V1,3363V1,3370V1,3373V,3375V,3377V4,3384V1,3387V1,3390V3,3395V1,3399V2,3407V,3409V,3412V3,3418V2,3423V1,3427V5,3434V1,3437V1,3440V2,3444V,3446V2,3450V1,3453V,3458V,3460V5,3467V2,3472V,3475V,3477V1,3480V,3482V1,3485V,3487V4,3494V,3496V,3498V,3500V1,3505V2,3509V,3512V,3515V3,3520V3,3525V,3527V,3529V2,3533V,3537V,3540V,3542V,3544V,3546V,3549V2,3555V4,3561V7,3570V3,3575V1,3579V2,3583V3,3588V3,3594V3,3599V,3607V1,3610V,3612V,3614V,3616V2,3620V4,3629V2,3633V8,3644V,3646V,3649V,3658V2,3662V4,3669V1,3672V1,3675V,3677V1,3682V1,3685V,3687V1,3690V1,3694V1,3697V4,3704V1,3707V2,3711V4,3717V3,3722V1,3725V3,3730V,3732V1,3735V,3737V4,3744V,3746V1,3749V11,3763V4,3770V,3775V,3777V2,3781V2,3785V4,3791V2,3795V2,3799V1,3802V8,3812V4,3818V,3820V5,3831V2,3835V,3840V,3842V,3844V,3847V,3850V2,3854V,3856V4,3862V,3864V1,3869V2,3873V2,3878V,3880V,3882V,3885V8,3895V1,3898V,3900V,3902V2,3909V4,3915V1,3918V1,3921V2,3925V6,3933V1,3936V10,3950V1,3953V1,3956V4,3962V,3964V3,3971V,3975V6,3984V,3987V5,3995V1,4000Q,4005Q9,4017Q5,4025Q,4030Q2,4034Q3,4051Q,4053Q2,4059Q2,4064Q6,4073Q5,4101Q24,4127Q6,4151Q10,4163Q2,4169Q5,4178Q1,4183Q1,4205Q,4207Q14,4223Q5,4230Q,4270Q2,4275Q,4280Q,4285Q,4287Q,4300Q1,4303Q4,4309Q5,4340Q7,4350Q,4352Q13,4370Q8,4380Q2,4383N,4384Q1,4387Q1,4390Q,4400Q8,4410Q3,4415Q13,4454Q1,4461Q1,4465Q,4467Q1,4470Q2,4474Q1,4477Q5,4486Q8,4496Q2,4500Q21,4550Q25,4580Q1,4600Q1,4605Q1,4608Q,4610Q5,4620Q1,4625Q2,4630Q,4650Q,4655Q,4659Q1,4662Q,4670Q1,4673Q1,4676Q2,4680Q,4694Q1,4697Q,4699Q8,4709Q19,4730Q3,4735Q11,4750Q1,4753Q1,4756Q1,4798Q14,4814Q11,4828Q2,4849Q1,4852Q,4854Q7,4865Q,4868Q20,4890Q2,4895Q,5000S,5006S19,5031S4,5037S15,5061S9,5072S4,5081S17,5106S12,5120S1,5125S2,5131S3,5136S6,5144S,5150S24,5201S3,5210S4,5220S3,5231S7,5240S5,5250S6,5259S14,5275S5,5290S1,5301S3,5306S5,5320S2,5330S3,5340S6,5350S7,5360S,5371S3,5381S,5400S1,5410S12,5431S3,5440S,5451S4,5460S2,5464S,5470S3,5480S3,5485S,5490S1,5493S,5495S,5501S1,5510S,5520S3,5540S,5550S,5552S,5554S2,5558S,5560S,5570S3,5575S2,5580S3,5600S9,5611S,5630S3,5640S2,5650S2,5654S1,5660S1,5670S1,5680S,5690S,5700S1,5710S,5713S,5715S,5717S,5719S1,5722S3,5730S4,5950S,6000W,6003W9,6014W24,6041W3,6050W24,6076W,6081W3,6090W,6100W12,6121W5,6147W29,6180W,6207W4,6213W2,6218W3,6223W7,6232W1,6236W1,6239W1,6243W1,6251W5,6258W,6260W,6262W,6271W,6275W,6280W2,6284W2,6288W,6290W,6302W,6304W,6306W,6308W1,6311W2,6315W3,6320W4,6326W2,6330W,6333W,6335W3,6341W,6343W,6346W,6348W,6350W3,6355W4,6361W,6363W,6365W,6367W3,6372W1,6375W,6383W3,6390W8,6401W,6403W,6405W,6407W,6409W6,6418W14,6434W4,6440W,6442W1,6445W3,6450W,6452W,6460W3,6465W3,6470W,6472W1,6475W2,6479W1,6484W1,6487W3,6501W6,6509W10,6521W1,6525W,6528W,6530W,6532W,6535W2,6556W,6558W,6560W,6562W,6564W,6566W3,6571W1,6574W1,6603W,6605W1,6608W1,6612W2,6616W,6620W,6623W,6625W,6627W1,6630W2,6635W,6638W2,6642W,6646W,6701W,6705W,6707W,6710W4,6716W,6718W,6720W3,6725W1,6728W,6731W,6733W,6740W,6743W,6751W,6753W1,6758W,6760W2,6765W,6770W,6798W1,6803W,6832W,6849W,6865W,6900W,6902W1,6905W,6907W,6909W,6918W,6923W,6931W,6954W,6957W,6980W,6987W,6991W,7000T1,7004T1,7007T5,7015T12,7030T,7050T,7052T3,7109T,7112T1,7116T1,7119T1,7140T,7150T1,7155T,7162T1,7170T3,7175T5,7182T,7184T3,7190T,7209T7,7248T2,7252T13,7267T1,7270T,7275T2,7290T2,7300T7,7310T,7315T1,7320T2,7325T,7330T1,7466T4';
  var PCS = {};
  PC_DATA.split(',').forEach(function (r) {
    var start = parseInt(r.slice(0, 4), 10), st = STATE_CODE[r.charAt(4)], n = parseInt(r.slice(5) || '0', 10);
    for (var k = 0; k <= n; k++) PCS[('000' + (start + k)).slice(-4)] = st;
  });
  function rangeState(pc) {
    var n = parseInt(pc, 10);
    if (n >= 200 && n <= 299) return 'ACT';
    if (n >= 800 && n <= 999) return 'NT';
    if ((n >= 2600 && n <= 2618) || (n >= 2900 && n <= 2920)) return 'ACT';
    if (n >= 1000 && n <= 2999) return 'NSW';
    if ((n >= 3000 && n <= 3999) || (n >= 8000 && n <= 8999)) return 'VIC';
    if ((n >= 4000 && n <= 4999) || (n >= 9000 && n <= 9799)) return 'QLD';
    if (n >= 5000 && n <= 5999) return 'SA';
    if (n >= 6000 && n <= 6999) return 'WA';
    if (n >= 7000 && n <= 7999) return 'TAS';
    return null;
  }
  /* ---------- shared state ---------- */
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function write(s) { try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }
  var SHARED = read();
  function setShared(patch) {
    for (var k in patch) SHARED[k] = patch[k];
    write(SHARED);
    document.dispatchEvent(new CustomEvent('cw:dlv', { detail: SHARED }));
  }

  /* ---------- cart weight ---------- */
  var cartG = null;
  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (c) { cartG = c.total_weight || 0; document.dispatchEvent(new CustomEvent('cw:dlv-cart')); }).catch(function () {});
  }

  /* ---------- widget ---------- */
  function init(el) {
    if (el.__dlv) return; el.__dlv = true;
    var mode = el.dataset.mode;
    var input = el.querySelector('[data-dlv-input]');
    var hint = el.querySelector('[data-dlv-hint]');
    var find = el.querySelector('[data-dlv-find]');
    var result = el.querySelector('[data-dlv-result]');
    var priceEl = el.querySelector('[data-dlv-price]');
    var priceK = el.querySelector('[data-dlv-pricek]');
    var placeEl = el.querySelector('[data-dlv-place]');
    var facts = el.querySelector('[data-dlv-facts]');
    var lede = el.querySelector('[data-dlv-lede]');
    var variantG = null;
    try { variantG = el.dataset.variantG ? JSON.parse(el.dataset.variantG) : null; } catch (e) {}
    var form = mode === 'product' ? el.closest('.buybox, .summary, section, body').querySelector('form[data-calc], form[action*="/cart/add"]') : null;
    var lastPrice = null;

    function weightKg() {
      if (mode !== 'product') return (parseInt(el.dataset.cartG, 10) || 0) / 1000;
      var g = 0;
      if (form && variantG) {
        var idEl = form.querySelector('[name="id"]'), qEl = form.querySelector('[name="quantity"]');
        var per = idEl ? (variantG[idEl.value] || 0) : 0;
        g = per * Math.max(1, parseInt(qEl && qEl.value, 10) || 1);
      }
      var inCart = cartG == null ? (parseInt(el.dataset.cartG, 10) || 0) : cartG;
      return { item: g / 1000, cart: inCart / 1000, total: (g + inCart) / 1000 };
    }

    function animate(to) {
      if (reduce || lastPrice == null || lastPrice === to) { priceEl.textContent = money(to); lastPrice = to; return; }
      var from = lastPrice, t0 = null; lastPrice = to;
      el.classList.remove('is-flash'); void el.offsetWidth; el.classList.add('is-flash');
      (function step(t) {
        if (!t0) t0 = t;
        var k = Math.min(1, (t - t0) / 380), e = 1 - Math.pow(1 - k, 3);
        priceEl.textContent = money(from + (to - from) * e);
        if (k < 1) requestAnimationFrame(step); else priceEl.textContent = money(to);
      })(performance.now());
    }

    function li(text) { var x = document.createElement('li'); x.innerHTML = text; return x; }

    function render() {
      var choice = 'deliver';
      el.dataset.choice = choice;
      el.querySelectorAll('[data-dlv-opt]').forEach(function (b) { b.setAttribute('aria-checked', b.dataset.dlvOpt === choice ? 'true' : 'false'); });
      el.querySelectorAll('[data-dlv-panel]').forEach(function (p) { p.hidden = p.dataset.dlvPanel !== choice; });
      if (lede) lede.textContent = 'Delivered Australia-wide';
      if (choice !== 'deliver') return;

      var loc = SHARED.loc;
      if (!loc || !loc.pc) { find.hidden = false; result.hidden = true; return; }
      find.hidden = true; result.hidden = false;
      placeEl.textContent = 'Postcode ' + loc.pc + ', ' + loc.state;

      var w = weightKg(), kg = typeof w === 'number' ? w : w.total;
      var q = quote(kg, loc);
      facts.innerHTML = '';
      priceEl.classList.remove('is-quote');
      if (q.status === 'ok') {
        priceK.textContent = 'Estimated';
        animate(q.price);
        if (q.band) {
          facts.appendChild(li('Your order ≈ <b>' + kgText(kg) + '</b> · priced for up to ' + kgText(q.band.max)));
          if (mode === 'product' && w.cart > 0.05) facts.appendChild(li('Includes ' + kgText(w.cart) + ' already in your cart'));
          facts.appendChild(li(q.method));
          if (q.lead) facts.appendChild(li('Typically ' + q.lead));
        } else {
          facts.appendChild(li('Samples are posted Australia-wide'));
        }
      } else if (q.status === 'quote') {
        priceK.textContent = 'Large order';
        priceEl.textContent = 'Quote'; priceEl.classList.add('is-quote'); lastPrice = null;
        facts.appendChild(li('Orders over ' + kgText(q.max) + ' are quoted individually'));
        facts.appendChild(li('Call <a href="tel:' + String(CFG.phone).replace(/[^\d+]/g, '') + '">' + CFG.phone + '</a> for a delivery price'));
      } else {
        priceK.textContent = '';
        priceEl.textContent = '–'; lastPrice = null;
      }
    }

    /* postcode entry: resolves as soon as 4 valid digits are typed */
    function onType() {
      var v = input.value.replace(/\D/g, '').slice(0, 4);
      if (input.value !== v) input.value = v;
      el.classList.toggle('is-typing', v.length > 0 && v.length < 4);
      if (v.length < 4) { hint.hidden = true; return; }
      var st = PCS[v] || rangeState(v);
      if (!st) { hint.hidden = false; hint.textContent = 'We don’t recognise postcode ' + v + '. Check it, or call ' + CFG.phone + ' for a delivery quote.'; return; }
      hint.hidden = true;
      el.classList.add('is-loading');
      setTimeout(function () { el.classList.remove('is-loading'); input.value = ''; setShared({ loc: { pc: v, state: st } }); }, reduce ? 0 : 220);
    }
    input.addEventListener('input', onType);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); onType(); } });

    el.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-dlv-opt]');
      if (opt) { setShared({ choice: opt.dataset.dlvOpt }); if (opt.dataset.dlvOpt === 'deliver' && !(SHARED.loc && SHARED.loc.pc)) setTimeout(function () { input.focus(); }, 60); return; }
      if (e.target.closest('[data-dlv-change]')) { setShared({ loc: null }); setTimeout(function () { input.focus(); }, 30); }
    });
    el.addEventListener('keydown', function (e) {
      if (!e.target.matches('[data-dlv-opt]') || (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight')) return;
      var next = e.target.dataset.dlvOpt === 'deliver' ? 'pickup' : 'deliver';
      setShared({ choice: next }); el.querySelector('[data-dlv-opt="' + next + '"]').focus(); e.preventDefault();
    });

    document.addEventListener('cw:dlv', render);
    document.addEventListener('cw:dlv-cart', render);
    if (form) {
      form.addEventListener('input', render);
      form.addEventListener('change', render);
      form.addEventListener('click', function (e) { if (e.target.closest('[data-qty-step]')) setTimeout(render, 0); });
      form.addEventListener('submit', function () { setTimeout(fetchCart, 1200); });
    }
    render();
  }

  function scan(root) { (root || document).querySelectorAll('[data-dlv]').forEach(init); }
  scan();
  if (document.querySelector('[data-dlv][data-mode="product"]')) fetchCart();
  new MutationObserver(function (m) {
    for (var i = 0; i < m.length; i++) for (var j = 0; j < m[i].addedNodes.length; j++) {
      var n = m[i].addedNodes[j];
      if (n.nodeType === 1) { if (n.matches('[data-dlv]')) init(n); else if (n.querySelector('[data-dlv]')) scan(n); }
    }
  }).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('storage', function (e) { if (e.key === KEY) { SHARED = read(); document.dispatchEvent(new CustomEvent('cw:dlv', { detail: SHARED })); } });
})();